import Vue from 'vue'
import Vuex from 'vuex'

import error from './modules/error'
import user from './modules/user'
import employee from './modules/employee'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    isLoading: false,
    collapsedSidebar: false,
    fixedNavbar: true
  },
  mutations: {
    toggleSidebar(state) {
      state.collapsedSidebar = !state.collapsedSidebar
    },
    toggleLoading(state, isLoading) {
      state.isLoading = isLoading
    },
    toggleFixedNavbar(state) {
      state.fixedNavbar = !state.fixedNavbar
    }
  },
  actions: {
  },
  modules: {
    error,
    user,
    employee
  }
})
